import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-virginia-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./virginia-state-form.component.html",
  styleUrl: "./virginia-state-form.component.scss",
})
export class VirginiaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
